import { GetMainNavResponse } from './types/get-main-nav.type';

export type PrimaryNavItems = GetMainNavResponse[number]['items'];

/**
 * Safely extracts primary nav items from a main-nav API payload.
 * Returns [] when the payload is missing, empty (e.g. HTTP 204), or not an array.
 */
export const getPrimaryNavItems = (data: unknown): PrimaryNavItems => {
	if (!Array.isArray(data)) {
		return [];
	}

	return (
		(data as GetMainNavResponse).find(
			({ navgroup }) => navgroup === 'primary'
		)?.items ?? []
	);
};
